import type { ShareResourceType, ShareUrlPrefix } from '~/types/shareAccess';

export const SHARE_TOKEN_PATTERN = /^[a-zA-Z0-9]{6,32}$/;

export function shareUrlPrefixForResource(type: ShareResourceType): ShareUrlPrefix {
  return type === 'vet_card' ? 'pet' : 'doc';
}

export function buildSharePath(prefix: ShareUrlPrefix, token: string): string {
  return `/share/${prefix}/${token}`;
}

export function buildShareUrl(origin: string, prefix: ShareUrlPrefix, token: string): string {
  const base = origin.replace(/\/+$/, '');
  return `${base}${buildSharePath(prefix, token)}`;
}

export function resolveShareOrigin(fallbackOrigin = 'https://vetsy.ru'): string {
  if (import.meta.client && typeof window !== 'undefined') {
    return window.location.origin;
  }

  return fallbackOrigin;
}

export function isValidShareToken(token: string | undefined | null): boolean {
  return !!token && SHARE_TOKEN_PATTERN.test(token);
}

export function shareToggleLabel(type: ShareResourceType): string {
  return type === 'vet_card' ? 'Доступ ко всей веткарте' : 'Доступ к документу';
}

/** Текст, которым ссылка уходит в системный Web Share. */
export function shareTargetLabel(type: ShareResourceType): string {
  return type === 'vet_card' ? 'Ссылка на веткарту' : 'Ссылка на документ';
}
